import useSWR, { type SWRResponse } from "swr";
import type { CountryType, Nullable } from "../../../@types/generic";
import { numberToString } from "../../../helpers/formatters/values";
import { useCountry } from "../../../hooks/useCountry";
import { QUERY_NAME_LOCATION_SUMMARY } from "../../cacheKeys";
import { fetcher } from "../index";
import type { LocationSummary } from "../types/locationSummary";

const fetchLocationSummary = async (
    code: string,
    country: CountryType,
    limitForecastSummaryItems?: number
): Promise<Nullable<LocationSummary>> =>
    fetcher<LocationSummary>(
        {
            path: `/location-summary/${code}/`,
            params: { limitForecastSummaryItems },
        },
        { country }
    )
        .then(({ data }) => data)
        .catch(() => null);

export const useLocationSummary = (
    code: Nullable<string | undefined>,
    limitForecastSummaryItems?: number
): SWRResponse<Nullable<LocationSummary>> => {
    const country = useCountry();
    const { data, isLoading, ...rest } = useSWR<Nullable<LocationSummary>>(
        numberToString(code) !== ""
            ? [
                  QUERY_NAME_LOCATION_SUMMARY,
                  code,
                  limitForecastSummaryItems,
                  country,
              ]
            : null,
        () =>
            fetchLocationSummary(
                code as string,
                country,
                limitForecastSummaryItems
            )
    );

    return {
        data,
        isLoading: isLoading || data === undefined,
        ...rest,
    };
};
